import {connect} from 'react-redux';
import FieldDatepicker from './FieldDatepicker';

const mapStateToProps = ({
                           locales: {current: locale}
                         }) => ({locale});

export default connect(
  mapStateToProps,
  null
)(FieldDatepicker);
